import '../css/intl-selection-map.scss';
import $ from '@modules/jquery-import';

$( document ).ready( function () {
    var $content = $( '#world-map-container' );
    $content.on( 'mouseenter mouseleave', '.country-selector', function ( e ) {
        var action = e.type === 'mouseenter' ? 'addClass' : 'removeClass';
        $content[action]( 'hasActive' );
        $( this )[action]( 'active' );
    } )
} );

